import { slideDown, slideToggle, slideUp } from '../helpers';

export function initDetailsAnimation(container = '', allOpen = true) {
	if (!container) {
		container = document;
	}

	const details = container.querySelectorAll('details');
	details.forEach((detail) => {
		const content = detail.querySelector('.details-content');
		if (content) {
			detail.classList.add('cursor-pointer');
			content.classList.add('hidden');
			detail.addEventListener('click', function (e) {
				const duration = 300;
				// Close all other details
				if (!allOpen) {
					const siblings = detail.parentNode.querySelectorAll('details');
					siblings.forEach((sibling) => {
						if (!sibling.contains(e.target)) {
							const siblingContent = sibling.querySelector('.details-content');
							if (siblingContent) {
								slideUp(siblingContent, duration);
							}
							sibling.classList.remove('open');
							window.setTimeout(() => sibling.removeAttribute('open'), duration);
						}
					});
				}

				if (!content.contains(e.target)) {
					e.preventDefault();
					const isClosed = !detail.hasAttribute('open');
					if (isClosed) {
						// Opening
						detail.setAttribute('open', '');
						detail.classList.add('open');
						slideDown(content, duration);
					} else {
						// Closing
						detail.classList.remove('open');
						slideUp(content, duration);
						window.setTimeout(() => detail.removeAttribute('open'), duration);
					}
				}
			});
		}
	});
}
